<template>
  <div>
    <v-card :style="[
      $vuetify.breakpoint.smAndDown
        ? { 'min-height': '100vh', 'background-color': '#f9f9f9' }
        : { 'background-color': '#f9f9f9' },
    ]">
      <div style="margin-left: 10px; margin-right: 10px">
        <div class="pt-8" style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          ">
          Room Booking
          <v-icon size="30"> mdi-home-account </v-icon>
        </div>
        <v-card-text>
          <div>
            <v-card elevation="10" style="padding: 2%; margin-bottom: 2%; margin-top: 2%">
              <v-row>
                <v-col cols="12" sm="6" md="2" lg="2" class="pt-5">
                  <v-text-field label="Amenity" append-icon="mdi-database-search-outline" v-model="search"
                    clearable outlined dense></v-text-field>
                
                </v-col>
                <v-col cols="12" sm="6" md="2" lg="2" class="pt-5">
                  <v-menu v-model="menuStartDate" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="startDate" label="Start Date" append-icon="mdi-calendar" outlined dense
                        readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                    </template>
                    <v-date-picker v-model="startDate" @change="menuStartDate = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="2" lg="2" class="pt-5">
                  <v-menu v-model="menuEndDate" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="endDate" label="End Date" append-icon="mdi-calendar" outlined dense
                        readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                    </template>
                    <v-date-picker v-model="endDate" @change="menuEndDate = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="2" lg="2" class="pt-5">
                  <v-autocomplete :items="ResidenceDDL" item-value="residenceID" item-text="unitNumber"
                    label="Residence" clearable v-model="searchResidenceID" outlined dense></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="2" lg="2" class="pt-5">
                  <v-autocomplete :items="PersonResidenceDDL" item-value="personID" item-text="person"
                    label="Name" v-model="searchPersonID" required clearable outlined dense></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="2" lg="2" class="pt-5">
                  <v-autocomplete :items="statusList" label="Status" v-model="statusSearch" required clearable outlined
                    dense></v-autocomplete>
                </v-col>
                <!-- <v-col cols="12" sm="6" md="3" lg="3" class="pt-5">
                  <v-text-field label="Search" append-icon="mdi-database-search-outline" v-model="search"
                    v-on:keyup.enter="SearchCard(search)" clearable outlined dense></v-text-field>
                </v-col> -->

                <v-col cols="12" sm="12" md="12" lg="12" style="text-align: end">
                  <v-hover v-slot="{ hover }">
                    <v-btn :color="'blue'" class="ma-2 white--text" :elevation="hover ? 10 : 2"
                      :class="{ 'on-hover': hover }" @click="SearchgettransactionDataRoomBooking()">
                      Search

                      <v-icon right> mdi-magnify </v-icon>
                    </v-btn>
                  </v-hover>
                  <!-- <v-hover v-slot="{ hover }">
                    <v-btn v-if="permissionsPage.create" color="green" class="ma-2 white--text"
                      :elevation="hover ? 10 : 2" :class="{ 'on-hover': hover }"
                      @click="OpenCardDialog('create', null)">
                      Create
                      <v-icon right> mdi-plus </v-icon>
                    </v-btn>
                  </v-hover> -->
                </v-col>
              </v-row>
            </v-card>
            <v-card v-if="show" elevation="10" style="padding: 2%; margin-bottom: 2%;margin-top: 1%; ">
              <v-data-table :headers="headers" :items="roombookingList" :options.sync="options" hide-default-footer style="color: #332f2fde"
                :items-per-page="itemsPerPage" :page.sync="page" single-line hide-details>
                <template v-slot:item="{ item, index }">
                  <tr>
                    <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                    <td class="header-table-css">{{ item.title }}</td>
                    <td class="header-table-css">{{ item.statuses }}</td>
                    <td class="header-table-css">{{ persontoname(item.personID,item.residentID) }}</td>
                    <!-- <td class="header-table-css">{{ item.idRoom }}</td> -->
                    <td class="header-table-css">{{ resdidenceidtoname(item.residentID) }}</td>

                    <td class="header-table-css">{{ ChangeFormatDate(item.start) }}</td>
                    <td class="header-table-css">{{ ChangeFormatDate(item.end) }}</td>
                    <td class="header-table-css">{{ ChangeFormatDate(item.updateTime) }}</td>
                    <!-- <td class="header-table-css">{{ item.details }}</td> -->

                    <td style="text-align: center; min-width: 150px">
                      <v-btn class="mx-2" dark small color="blue" @click="OpenCardDialog('update', item)">
                        Edit
                      </v-btn>
                      <!-- <v-btn v-show="item.statuses == 'initialized'" class="mx-2" dark small color="orange"
                        @click="updateBooking(item._id)">
                        Cancel
                      </v-btn> -->
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <br />
              <v-row class="mt-2">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3">
                  <v-pagination v-model="page" :total-visible="20" :length="pageCount"
                    @input="ChangePage(page)"></v-pagination>
                </v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete solo label="10/page" v-model="itemsPerPage" @input="ChangePerPage(itemsPerPage)"
                    :items="items"></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
            <v-card v-else elevation="10" style="padding: 2%; margin-bottom: 2%">
              <v-row>
                <v-col cols="12" sm="8" md="8" class="mt-2">
                  <div style="
                      font-size: 20px;
                      margin-left: 1rem;
                      margin-right: 1rem;
                      color: #444444;
                    ">
                    Booking
                    <v-icon size="30"> mdi-book-account-outline </v-icon>
                  </div>

                  <v-row>
                    <v-col cols="12" md="5" style="text-align: center">
                      <v-autocomplete v-model="towerID" :items="towerListArray" hide-details hide-selected
                        item-text="towerName" item-value="towerID" @change="gettransactionDataRoomBooking()">
                      </v-autocomplete>
                    </v-col>
                  </v-row>

                </v-col>



                <v-col cols="12" sm="4" md="4">
                  <template>
                    <v-row class="fill-height">
                      <v-col>
                        <v-sheet height="70">
                          <v-toolbar flat>
                            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                              Today
                            </v-btn>
                            <v-btn fab text small color="grey darken-2" @click="prev">
                              <v-icon small> mdi-chevron-left </v-icon>
                            </v-btn>
                            <v-btn fab text small color="grey darken-2" @click="next">
                              <v-icon small> mdi-chevron-right </v-icon>
                            </v-btn>
                            <v-toolbar-title v-if="$refs.calendar">
                              {{ $refs.calendar.title }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-menu bottom right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                                  <span>{{ typeToLabel[type] }}</span>
                                  <v-icon right> mdi-menu-down </v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item @click="type = 'day'">
                                  <v-list-item-title>Day</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = 'week'">
                                  <v-list-item-title>Week</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = 'month'">
                                  <v-list-item-title>Month</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = '4day'">
                                  <v-list-item-title>4 days</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-toolbar>
                        </v-sheet>
                        <v-sheet height="600">
                          <v-calendar ref="calendar" v-model="focus" color="primary" :events="events"
                            :event-color="getEventColor" :type="type" @click:event="showEvent" @click:more="viewDay"
                            @click:date="viewDay" @change="updateRange"></v-calendar>
                          <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement"
                            offset-x>
                            <v-card color="grey lighten-4" min-width="350px" flat>
                              <v-toolbar :color="selectedEvent.color" dark>
                                <v-btn icon>
                                  <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                  <v-icon>mdi-heart</v-icon>
                                </v-btn>
                                <v-btn icon>
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </v-toolbar>
                              <v-card-text>
                                <span v-html="selectedEvent.details"></span>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn text color="secondary" @click="selectedOpen = false">
                                  Cancel
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-menu>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </template>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>



    <v-dialog v-model="CardDialog" persistent max-width="800px">
      <v-card>
        <v-card-title style="background-color: black; color: white">
          <span class="text-h5">Room Booking</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-row>
                  <v-col cols="12" sm="5" md="5">
                    <v-autocomplete :items="PersonResidenceDDL" item-value="personID" item-text="person"
                      label="Person Residence *" clearable v-model="PersonresidenceID"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-autocomplete :items="ResidenceDDL" item-value="residenceID" item-text="unitNumber"
                      label="Residence *" clearable v-model="residenceID"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    ">
                    <v-btn variant="outlined" color="primary" width="140" @click="Getfac()">
                      Select
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-menu v-model="menuDateEvent" :close-on-content-click="false" transition="scale-transition"
                      offset-y min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="DateEvent" label="Date" append-icon="mdi-calendar" readonly
                          v-bind="attrs" v-on="on" clearable></v-text-field>
                      </template>
                      <v-date-picker v-model="DateEvent" @change="menuDateEvent = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-autocomplete :items="time" label="Start Time" v-model="startTime" required
                      clearable></v-autocomplete>

                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-autocomplete :items="time" label="End Time" v-model="endTime" required
                      clearable></v-autocomplete>

                  </v-col>

                  <v-col cols="12" sm="4" md="4">
                    <v-text-field label="Title" v-model="Title" clearable></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="8" md="8">
                    <v-text-field label="Detail" v-model="Detail" clearable></v-text-field>
                  </v-col>
                  <v-col v-if="facility != ''" cols="12" sm="12" md="12">
                    <v-card>
                      <v-card-title style="background-color: skyblue; color: white">
                        <span class="text-h5">{{ facility }}</span>
                      </v-card-title>
                    </v-card>
                  </v-col>


                </v-row>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col cols="12" sm="12" md="12" style="text-align: end; margin-bottom: 20px">
              <v-spacer></v-spacer>
              <v-btn class="ma-2" style="min-width: 100px" color="success" @click="addBooking()">
                create
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>

              <v-btn variant="outlined" color="silver" style="min-width: 100px" append-icon="mdi-close-circle-outline"
                @click="CardDialog = false">
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="EditCardDialog" persistent max-width="800px">
      <v-card>
        <v-card-title style="background-color: black; color: white">
          <span class="text-h5">Edit Room Booking : {{ Title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-autocomplete :items="PersonResidenceDDL" item-value="personID" item-text="person"
                      label="Person Residence *" clearable v-model="PersonresidenceID" disabled></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-autocomplete :items="ResidenceDDL" item-value="residenceID" item-text="unitNumber"
                      label="Residence *" clearable v-model="residenceID" disabled></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-menu v-model="menuDateEvent" :close-on-content-click="false" transition="scale-transition"
                      offset-y min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="DateEvent" label="Date" append-icon="mdi-calendar" readonly
                          v-bind="attrs" v-on="on" clearable></v-text-field>
                      </template>
                      <v-date-picker v-model="DateEvent" @change="menuDateEvent = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-autocomplete :items="time" label="Start Time" v-model="startTime" required
                      clearable></v-autocomplete>

                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <v-autocomplete :items="time" label="End Time" v-model="endTime" required
                      clearable></v-autocomplete>

                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6">
                    <v-autocomplete :items="statusList" label="Status" v-model="status" required
                      clearable></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-textarea label="Remark From Resident" v-model="Detail" clearable></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea label="Remark From Concierge" v-model="DetailConcierge" clearable></v-textarea>
                  </v-col>
                  <v-col v-if="facility != ''" cols="12" sm="12" md="12">
                    <v-card>
                      <v-card-title style="background-color: skyblue; color: white">
                        <span class="text-h5">{{ facility }}</span>
                      </v-card-title>
                    </v-card>
                  </v-col>


                </v-row>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col cols="12" sm="12" md="12" style="text-align: end; margin-bottom: 20px">
              <v-spacer></v-spacer>
              <v-btn class="ma-2" style="min-width: 100px" color="success" @click="EditBooking()">
                Update
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn>

              <v-btn variant="outlined" color="silver" style="min-width: 100px" append-icon="mdi-close-circle-outline"
                @click="EditCardDialog = false">
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="facdaialog" persistent max-width="800px">
      <v-card>
        <v-card-title style="background-color: black; color: white">
          <span class="text-h5">Room Booking</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-data-table :headers="headersfac" :items="roombookingListFac" hide-default-footer
                  style="color: #332f2fde" :items-per-page="50" :page.sync="page" single-line hide-details>
                  <template v-slot:item="{ item, index }">
                    <tr>
                      <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                      <td class="header-table-css">{{ item.name }}</td>
                      <td class="header-table-css">{{ item.areaNameEn }}</td>
                      <!-- <td class="header-table-css">{{ item.openTime }}</td>
                    <td class="header-table-css">{{ item.closeTime }}</td> -->

                      <td style="text-align: center; min-width: 150px">
                        <v-btn class="mx-2" dark small color="blue" @click="Selectfac(item)">
                          Select
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col cols="12" sm="12" md="12" style="text-align: end; margin-bottom: 20px">
              <v-spacer></v-spacer>
              <!-- <v-btn class="ma-2" style="min-width: 100px" color="success" @click="addBooking()">
                create
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </v-btn> -->

              <v-btn variant="outlined" color="silver" style="min-width: 100px" append-icon="mdi-close-circle-outline"
                @click="facdaialog = false">
                Done
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="selectTowerDialog" persistent max-width="1000">
      <v-card>
        <v-card-title class="text-h5">
          Use Google's location service?
        </v-card-title>

        <v-card-text>
          <div v-if="cards.length > 0">
            <carousel-3d :controls-visible="true" :clickable="false" :disable3d="!disable3d"
              :space="!disable3d ? 356 : 250" :width="340" :height="480" :border="1" style="border-radius: 10px">
              <slide v-for="(card, i) in cards" :index="i" :key="card.description">
                <figure class="zoom" style="
                    cursor: pointer;
                    background-color: aliceblue;
                    border-radius: 30px;
                  ">
                  <img :src="card.src" class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="480px" @click="
                      routerPage(
                        card.groupID == 5 || card.groupID == 6
                          ? card.description
                          : card.groupName
                      )
                      " />
                  <figcaption>
                    {{
                      card.groupID == 5 || card.groupID == 6
                        ? card.description
                        : card.groupName
                    }}
                  </figcaption>
                </figure>
              </slide>
            </carousel-3d>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loadingDialog" persistent width="auto">
      <div class="loading-box">
        <div class="inter-load">
          <div class="rect rect1"></div>
          <div class="rect rect2"></div>
          <div class="rect rect3"></div>
          <div class="rect rect4"></div>
          <div class="rect rect5"></div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import RoomBooking from "@/models/RoomBooking";
import { eventBus } from "../../main";
import { Carousel3d, Slide } from "vue-carousel-3d";
// import { display } from "html2canvas/dist/types/css/property-descriptors/display";

export default {
  name: "TransactionRoomBooking",
  components: {
    Carousel3d,
    Slide,
  },
  data() {
    return {
      url: enurl.apiUrl,
      permissionsPage: [],

      // RoomBooking information
      startDate: "",
      endDate: "",
      search: null,
      activeSearch: null,
      menuStartDate: false,
      menuEndDate: false,
      activeSwitch: true,
      rules: { required: (value) => !!value || "Required." },
      roombookingList: [],
      roombookingListFac: [],
      roombookingID: null,
      unitNumber: null,
      houseId: null,
      remark: null,
      residentID: null,
      personID: null,
      show: true,
      cards: [],

      roomModel: new RoomBooking(),
      statusSearch: null,
      status: null,
      statusList: ['initialized', 'canceled', 'checkedin', 'checkedout', 'rejected', 'approved'],

      // Tower information
      roombookingAuthFloorArray: [],
      towerListArray: [],
      defaultArray: [],
      towerNameList: "",
      getTowerZone: [],
      tenant: [],
      checkbox: [],
      checkboxFloor: [],
      locationMapping: [],
      locationFloorMap: [],
      towerList: [],
      towername: "",
      floorList: [],
      zoneList: [],
      defaultFloor: [],
      selectFloor: [],
      TenantList: [],
      TenantID: null,

      name: null,
      Title: null,
      Detail: null,
      DetailConcierge: null,
      startTime: null,
      startMenu: null,
      endMenu: null,
      endTime: null,
      menuDateEvent: null,
      DateEvent: null,
      id: null,
      // Page information
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      items: [10, 15, 20, 50, 100],
      editDialog: false,
      editStatus: false,
      loadingDialog: false,
      CardDialog: false,
      EditCardDialog: false,
      facdaialog: false,
      facility: "",

      focus: "",
      type: "day",
      typeToLabel: {
        month: "Month",
        week: "Week",
        day: "Day",
        "4day": "4 Days",
      },

      searchResidenceID: null,
      searchPersonID: null,

      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      PersonResidenceDDL: [],
      PersonresidenceID: null,
      ResidenceDDL: [],
      residenceID: null,
      colors: [
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1",
      ],
      names: [
        "Meeting",
        "Holiday",
        "PTO",
        "Travel",
        "Event",
        "Birthday",
        "Conference",
        "Party",
      ],
      time: [
        "06:00",
        "06:30",
        "07:00",
        "07:30",
        "08:00",
        "08:30",
        "09:00",
        "09:30",
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
        "16:30",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
        "19:30",
        "20:00",
        "20:30",
        "21:00",
        "21:30",
        "22:00"
      ],

      selectTowerDialog: false,
      options: {},

      headers: [
        { text: "No", sortable: false, align: "left" },
        { text: "Amenity", sortable: true, align: "left" },
        { text: "Statuses", sortable: false, align: "left" },
        { text: "Name", sortable: false, align: "left" },
        // { text: "idRoom", sortable: false, align: "left" },
        { text: "Residence", sortable: false, align: "left" },
        { text: "Start", sortable: false, align: "left" },
        { text: "End", sortable: false, align: "left" },
        { text: "update Time", sortable: false, align: "left" },
        // { text: "Details", sortable: false, align: "left" },
        { text: "Action", sortable: false, align: "center" },
      ],
      headersfac: [
        { text: "No", sortable: false, align: "left" },
        { text: "Name", sortable: false, align: "left" },
        { text: "Area Name", sortable: false, align: "left" },
        // { text: "Open Time", sortable: false, align: "left" },
        // { text: "Close Time", sortable: false, align: "left" },
        { text: "Action", sortable: false, align: "center" },
      ],
    };
  },
  async mounted() {
    let Permision = localStorage.getItem("Permision");
    if (Permision == null || Permision == "") {
      this.$router.push("/Main");
    }
    let page = localStorage.getItem("page");
    this.permissionsPage = JSON.parse(Permision).find((x) => x.appName == page);

    await this.getResidenceDropdownList();
    await this.getPersonResidenceList();

    await this.gettransactionDataRoomBooking();
    // this.getRoomBookingTowerList();
    // this.GetRoleAuthFloors();
    // this.getTenantRoomBookingList();
    // this.$refs.calendar.checkChange();
  },
  watch: {
    checkbox() {
      let self = this;
      if (self.defaultArray.find((a) => a.towerID == self.towerName) != null) {
        self.defaultArray.find((a) => a.towerID == self.towerName).selectFloor =
          self.checkbox;
      }
    },
  },
  methods: {



    Selectfac(data) {
      let self = this;
      // console.log(data);
      self.id = data.idRoom;
      self.facility = data.nameEn;
      self.Title = data.nameEn;
      self.facdaialog = false;
    },

    Getfac() {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        page: 1,
        perpage: 50,

      };
      axios
        .post(`${self.url}RoomBooking/getDataRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.roombookingListFac = response.data.data.listData;
            self.facdaialog = true;
            // console.log(self.roombookingList);
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.loadingDialog = false;
        })
        .catch(function (error) {
          self.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },




    addBooking() {
      let that = this;
      that.loadingDialog = true;

      if (that.PersonresidenceID != null) {
        that.name = that.PersonResidenceDDL.find(x => x.personID == that.PersonresidenceID).person;
      }

      let temp = {
        id: that.id,
        title: that.Title,
        start: that.picker + ' ' + that.startTime,
        end: that.DateEvent + ' ' + that.endTime,
        details: that.Detail,
        residenceId: that.residenceID,
        person: [
          {
            name: that.name,
            email: that.PersonresidenceID,
            isOrganizer: true,
            isAttendee: false
          }
        ]
      };
      // console.log(temp);
      axios
        .post(`${that.url}RoomBooking/createRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            that.loadingDialog = false;
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          that.page = 1;
          that.gettransactionDataRoomBooking();
          that.CardDialog = false;
        })
        .catch(function (error) {
          that.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });

    },

    EditBooking() {
      let that = this;
      that.loadingDialog = true;

      if (that.PersonresidenceID != null) {
        that.name = that.PersonResidenceDDL.find(x => x.personID == that.PersonresidenceID).person;
      }

      let temp = {
        id: that.id,
        title: that.Title,
        start: that.DateEvent + ' ' + that.startTime,
        end: that.DateEvent + ' ' + that.endTime,
        details: that.Detail,
        remark: that.DetailConcierge,
        residenceId: that.residenceID,
        statuses: {
          currentStatus: that.status
        },
        person: [
          {
            name: that.name,
            email: that.PersonresidenceID,
            isOrganizer: true,
            isAttendee: false
          }
        ]
      };
      // console.log(temp);
      axios
        .post(`${that.url}RoomBooking/EditRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            that.loadingDialog = false;
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          that.page = 1;
          that.gettransactionDataRoomBooking();
          that.EditCardDialog = false;
        })
        .catch(function (error) {
          that.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });

    },
    updateBooking(id) {
      let that = this;
      that.loadingDialog = true;
      let temp = {
        id: id,
      };

      Swal.fire({
        title: "ยกเลิก?",
        text: "คุณต้องการ ยกเลิกการจองห้อง!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(`${that.url}RoomBooking/UpdateRoomBooking`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                that.loadingDialog = false;
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
              if (response.data.status == 2) {
                eventBus.$emit("logout");
              }
              that.page = 1;
              that.gettransactionDataRoomBooking();
              that.CardDialog = false;
            })
            .catch(function (error) {
              that.loadingDialog = false;
              if (error.response.status != 404) {
                Swal.fire({
                  icon: "error",
                  title: "Error...",
                  width: 900,
                  text: error.response.data.message,
                });
              }
            });
        } else {
          that.loadingDialog = false;
          that.CardDialog = false;
        }
      });
    },

    SearchgettransactionDataRoomBooking() {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        start: self.startDate == "" ? null : self.startDate,
        end: self.endDate == "" ? null : self.endDate,
        personID: self.searchPersonID == "" ? null : self.searchPersonID,
        residentID: self.searchResidenceID == "" ? null : self.searchResidenceID,
        status: self.statusSearch == "" ? null : self.statusSearch
      };
      axios
        .post(`${self.url}RoomBooking/gettransactionDataRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.roombookingList = response.data.data.listData;
            // console.log(self.roombookingList);
            self.pageCount = Math.ceil(
              response.data.data.total / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.loadingDialog = false;
        })
        .catch(function (error) {
          self.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    gettransactionDataRoomBooking() {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        start: self.startDate == "" ? null : self.startDate,
        end: self.endDate == "" ? null : self.endDate,
        personID: self.searchPersonID == "" ? null : self.searchPersonID,
        residentID: self.searchResidenceID == "" ? null : self.searchResidenceID,
        status: self.statusSearch == "" ? null : self.statusSearch
      };
      axios
        .post(`${self.url}RoomBooking/gettransactionDataRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.roombookingList = response.data.data.listData;
            // console.log(self.roombookingList);
            self.pageCount = Math.ceil(
              response.data.data.total / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.loadingDialog = false;
        })
        .catch(function (error) {
          self.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },



    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    // RoomBooking
    getDataRoomBooking1() {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        page: self.page,
        limit: self.itemsPerPage,
        types: "room",
      };
      self.facility("RoomBooking/authkey/facility", temp);
      self.loadingDialog = false;
    },
    SearchRoomBooking(data) {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        search: data,
        startDate: self.startDate,
        endDate: self.endDate,
        active:
          self.activeSearch == "Active"
            ? true
            : self.activeSearch == null
              ? null
              : false,
      };
      self.facility("RoomBooking/authkey/facility", temp);
      self.loadingDialog = false;
    },
    getResidenceDropdownList() {
      let self = this;
      axios
        .get(`${self.url}RoomBooking/getResidenceDropdownList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ResidenceDDL = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          self.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
    getPersonResidenceList() {
      let self = this;
      axios
        .get(`${self.url}RoomBooking/getPersonResidenceList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.PersonResidenceDDL = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          self.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
    addRoomBooking() {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        roombookingID: parseInt(self.roombookingID),
        unitNumber: self.unitNumber,
        houseId: self.houseId,
        remark: self.remark,
        active: self.activeSwitch,
        roombookingAuthFloorArray: self.defaultArray,
      };
      axios
        .post(`${self.url}RoomBooking/addRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.gettransactionDataRoomBooking();
            self.getTenantRoomBookingList();
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
      self.editDialog = false;
      self.loadingDialog = false;
    },
    updateRoomBooking() {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        roombookingID: parseInt(self.roombookingID),
        unitNumber: self.unitNumber,
        houseId: self.houseId,
        remark: self.remark,
        active: self.activeSwitch,
        roombookingAuthFloorArray: self.defaultArray,
        tenantID: self.TenantID,
      };
      axios
        .post(`${self.url}RoomBooking/updateRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.loadingDialog = false;
            self.editDialog = false;
            self.gettransactionDataRoomBooking();
            self.getTenantRoomBookingList();
          }
          self.loadingDialog = false;
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
      self.loadingDialog = false;
    },
    getRoomBookingByRoomBookingID(id) {
      let self = this;
      self.loadingDialog = true;
      let temp = {
        roombookingID: parseInt(id),
      };
      axios
        .post(`${self.url}RoomBooking/getRoomBookingByRoomBookingID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.bindingData(response.data.data);
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.loadingDialog = false;
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            self.loadingDialog = false;
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    openDialog(data) {
      let self = this;
      self.roomModel = data;
      // console.log(self.roomModel);
      self.editDialog = true;
      // console.log(data);
      // self.$refs.calendar.checkChange();
      // self.show = false;
    },
    OpenCardDialog(module, item) {
      let self = this;
      if (module == "create") {
        self.CardDialog = true;
      } else {
        self.bindingData(item);
      }
    },
    bindingData(data) {
      let self = this;
      // console.log(data);

      let startTime = data.start;
      let [date, time] = startTime.split("T");
      let shortTimeStart = time.substring(0, 5);

      let endTime = data.end;
      let timee = endTime.split("T")[1];
      let shortTimeEnd = timee.substring(0, 5);


      self.PersonresidenceID = data.personID;
      self.residenceID = data.residentID;
      self.id = data._id;
      self.Title = data.title;
      self.Detail = data.details;
      self.DetailConcierge = data.DetailConcierge;
      self.remark = data.remark == null ? '' : data.remark;
      self.DateEvent = date;
      self.startTime = shortTimeStart;
      self.endTime = shortTimeEnd;
      self.status = data.statuses;

      self.EditCardDialog = true;
    },
    closeDialog() {
      let self = this;
      self.roomModel = new RoomBooking();
      self.editDialog = false;

    },
    validateRoomBookingData() {
      if (
        this.unitNumber == "" ||
        this.unitNumber == null ||
        this.houseId == "" ||
        this.houseId == null
      ) {
        Swal.fire({
          icon: "warning",
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          showConfirmButton: false,
          timer: 1500,
        });
        return false;
      } else {
        return true;
      }
    },

    // Tower, Floor and Zone setting
    getRoomBookingTowerList() {
      let self = this;
      self.loadingDialog = true;
      axios
        .get(`${self.url}RoomBooking/getRoomBookingTowerList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.towerListArray = response.data.data;
            self.defaultArray = [];
            self.towerListArray.forEach((element) => {
              let tempData = {
                towerID: element.towerID,
                selectFloor: [],
                defaultFloor: [],
              };
              self.defaultArray.push(tempData);
            });
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
      self.loadingDialog = false;
    },

    getTenantRoomBookingList() {
      let self = this;
      self.loadingDialog = true;
      axios
        .get(`${self.url}RoomBooking/getTenantRoomBookingList`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.TenantList = response.data.data;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
        })
        .catch(function (error) {
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
      self.loadingDialog = false;
    },

    getDataZoneAndFloorByTowerID() {
      let self = this;
      self.loadingDialog = true;
      if (self.towerNameList == null) {
        self.getTowerZone = [];
        return;
      }
      let temp = {
        towerID: self.towerNameList,
      };
      axios
        .post(`${self.url}Tenant/getDataZoneAndFloorByTowerID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.checkbox = [];
            self.checkboxFloor = [];
            self.getTowerZone = response.data.data;
            self.locationMapping =
              self.getTowerZone.accessMapping.locationMapping;
            self.locationFloorMap =
              self.getTowerZone.accessMapping.locationFloorMap;
            self.towerName = self.getTowerZone.towerList.towerID;
            self.floorList = self.getTowerZone.towerList.floorList;
            self.zoneList = self.getTowerZone.towerList.zoneList;
            self.checkbox = self.defaultArray.find(
              (a) => a.towerID == self.towerName
            ).selectFloor;
            self.checkboxFloor = self.defaultArray.find(
              (a) => a.towerID == self.towerName
            ).defaultFloor;
            self.$forceUpdate();
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.loadingDialog = false;
          self.editDialog = true;
        })
        .catch(function (error) {
          self.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
    setDefaultFloor(value, checked) {
      let that = this;
      if (checked) {
        this.OneFloorInZone(value);
        if (that.checkbox.indexOf(value) != -1) {
          that.checkboxFloor.push(value);
        }
      } else {
        let index = that.checkboxFloor.indexOf(value);
        that.checkboxFloor.splice(index, 1);
      }
    },
    checkboxClick(value) {
      let that = this;

      that.checkboxFloor.forEach((x) => {
        if (that.checkbox.find((a) => a == x) == null) {
          let index = that.checkboxFloor.indexOf(value);
          that.checkboxFloor.splice(index, 1);
        }
      });
    },
    checkButton(value) {
      let that = this;
      let defaultFloor = that.checkboxFloor.find((x) => x == value);
      let selectFloor = that.checkbox.find((x) => x == value);
      if (defaultFloor != null && selectFloor != null) {
        return true;
      }

      return false;
    },
    CheckBoxData(floorID, zoneID) {
      let temp = "";
      let dataCheck = this.locationFloorMap.find(
        (x) => x.floorID == floorID && x.zoneID == zoneID
      );
      if (dataCheck != null) {
        temp = dataCheck.locationID;
        return temp;
      }
      return temp;
    },
    ZoneWithFloor(floorID, zoneID) {
      let dataCheck = this.locationFloorMap.find(
        (x) => x.floorID == floorID && x.zoneID == zoneID
      );
      if (dataCheck != null) {
        return false;
      }

      return true;
    },
    OneFloorInZone(value) {
      let that = this;
      let mainZoneID = this.locationMapping.find(
        (x) => x.locationID == value && x.towerID == this.towerName
      ).zoneID;

      let defaultData = this.defaultArray.find(
        (f) => f.towerID == this.towerName
      ).defaultFloor;

      defaultData.forEach((item) => {
        let findZoneDuplicate = this.locationMapping.find(
          (x) => x.locationID == item && x.towerID == this.towerName
        ).zoneID;
        if (mainZoneID == findZoneDuplicate) {
          if (that.checkbox.find((a) => a == value) != null) {
            let index = that.checkboxFloor.indexOf(item);
            that.checkboxFloor.splice(index, 1);
          }
        }
      });
    },
    GetRoleAuthFloors() {
      let that = this;
      that.loadingDialog = true;

      axios
        .get(`${that.url}Tenant/GetRoleAuthFloors`)
        .then(function (response) {
          if (response.data.status == 0) {
            that.getRoleAuthFloors = response.data.data;
            for (let i = 0; i < that.getRoleAuthFloors.length; i++) {
              that.getRoleAuthFloors[i].choose = false;
              that.getRoleAuthFloors[i].defaultFloor = false;
            }
            that.loadingDialog = false;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          that.loadingDialog = false;
        })
        .catch(function (error) {
          that.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

    resdidenceidtoname(data) {
      if (!data) return null;

      if (this.ResidenceDDL.find(x => x.residenceID == data) != undefined) {
        if (this.ResidenceDDL.find(x => x.residenceID == data).unitNumber == undefined) {
          return "Concierge";
        } else {
          return this.ResidenceDDL.find(x => x.residenceID == data).unitNumber;
        }

      } else {
        return '-';
      }


    },

    persontoname(data,id) {
      if (!data) return '';
      if(id == 99){
        return 'Concierge';
      }else{
          if (this.PersonResidenceDDL.find(x => x.personID == data) != undefined) {
        return this.PersonResidenceDDL.find(x => x.personID == data).person;
      } else {
        return '-';
      }
      }
    

    },

    // Additional function
    ChangeFormatDate(date) {
      if (!date) return null;

      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
    GetColor(value) {
      if (value == "1") {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },
    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },
    ChangePage(value) {
      let self = this;
      self.loadingDialog = true;
      self.page = value;
      let temp = {
        page: value,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        start: self.startDate == "" ? null : self.startDate,
        end: self.endDate == "" ? null : self.endDate,
        personID: self.searchPersonID == "" ? null : self.searchPersonID,
        residentID: self.searchResidenceID == "" ? null : self.searchResidenceID,
        status: self.statusSearch == "" ? null : self.statusSearch
      };
      axios
        .post(`${self.url}RoomBooking/gettransactionDataRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.roombookingList = response.data.data.listData;
            // console.log(self.roombookingList);
            self.pageCount = Math.ceil(
              response.data.data.total / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.loadingDialog = false;
        })
        .catch(function (error) {
          self.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },
    ChangePerPage(value) {
      let self = this;
      self.loadingDialog = true;
      self.page = 1;
      let temp = {
        page: 1,
        perpage: value,
        search: self.search == null ? "" : self.search,
        start: self.startDate == "" ? null : self.startDate,
        end: self.endDate == "" ? null : self.endDate,
        personID: self.searchPersonID == "" ? null : self.searchPersonID,
        residentID: self.searchResidenceID == "" ? null : self.searchResidenceID,
        status: self.statusSearch == "" ? null : self.statusSearch
      };
      axios
        .post(`${self.url}RoomBooking/gettransactionDataRoomBooking`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.roombookingList = response.data.data.listData;
            // console.log(self.roombookingList);
            self.pageCount = Math.ceil(
              response.data.data.total / self.itemsPerPage
            );
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.loadingDialog = false;
        })
        .catch(function (error) {
          self.loadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
        });
    },

  },
};
</script>

<style>
.v-data-table-header {
  background-color: black !important;
  color: #ffffff !important;
}

.v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

.header-table-css {
  text-align: left;
  cursor: pointer;
}
</style>
